import { Auth } from '@aws-amplify/auth'
import LOG from '../../../logging/Logger'
import { getCacheSubscription, putCacheSubscription } from './subscriptionCache'

export async function getCurrentSubscription() {
  let subscriptionDetails = getCacheSubscription()
  try {
    if (!subscriptionDetails) {
      LOG.info('Cache empty, retrieve user sub deets...')
      const currentUser = await Auth.currentAuthenticatedUser({
        bypassCache: true
      })
      if (currentUser.attributes) {
        subscriptionDetails = {
          productId: currentUser.attributes['custom:stripeProductId'],
          paymentMethodId: currentUser.attributes['custom:stripePayMethodId'],
          subEndDate: currentUser.attributes['custom:stripeSubEndDt'],
          subscriptionId: currentUser.attributes['custom:stripeSubscriptionId']
        }

        putCacheSubscription(subscriptionDetails)
      }
    }
  } catch (err) {
    LOG.error('getCurrentSubscription', err)
  }
  return subscriptionDetails
}

export default getCurrentSubscription
